/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Checkbox, Col, Divider, Row
} from 'antd';
import React, { useState } from 'react';
import {
  Button, Image, Typography
} from 'tfc-components';

import ChoosePackage from './ChoosePackage';

import {
  IBillingInfo, IBusinessInfo, IIndividualInfo, IPackage
} from '.';

import imgCard from 'assets/images/card_notice.png';
import nganLuongImg from 'assets/images/nganluong-logo-color.png';
import Modal from 'components/organisms/Modal';
import mapModifiers from 'utils/functions';

interface Props {
  total: number;
  billingType: 'one-time' | 'subscription';
  billingData: IBillingInfo;
  handleCheckout: () => void;
  duration: 'monthly' | 'yearly';
  visiblePackages:
  { id: string; name: string; price: number; duration: number; quantity: number }[];
  mainPackage: IPackage | null
}

const paymentMethodsSubscription = [
  'JCB',
  'Master Card',
  'Visa'
];

const paymentMethodsOnetime = [
  'Viet QR',
  'ATM Card',
  'Internet Banking',
  'E-Wallet',
  'JCB',
  'Master Card',
  'Visa'
];

const handlePhoneChange = (value: string) => {
  if (value.startsWith('+84') && value.length === 12) {
    const localNumber = `0${value.slice(3)}`;
    return localNumber;
  }
  return value;
};

const Confirmation: React.FC<Props> = ({
  total, billingData, billingType, handleCheckout,
  duration, mainPackage, visiblePackages
}) => {
  const [checked, setChecked] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  return (
    <div className="p-checkout_confirmation">
      <div className="p-checkout_confirmation_wrap">
        <ChoosePackage
          billingType={billingType}
          total={total}
          readonly
          width="158px"
          duration={duration}
          visiblePackages={visiblePackages}
          mainPackage={mainPackage}
        />
        <div className="p-checkout_spacingBottom">
          <Typography.Text fontweight="600" extendClasses="p-checkout_titleProduct p-checkout_billingInfo_spacing fs-20x24">
            Buyer Information
          </Typography.Text>
          <div className="p-checkout_buyerInfo">
            <Row gutter={[16, 16]}>
              <Col className="p-checkout_buyerInfo_col">
                <Typography.Text fontweight="600" extendClasses="p-checkout_billingType_formLabel p-home_demo_formLabel fs-14x18">Full name</Typography.Text>
                <Typography.Text extendClasses="p-checkout_text">{billingData.fullName}</Typography.Text>
              </Col>
              <Col className="p-checkout_buyerInfo_col">
                <Typography.Text fontweight="600" extendClasses="p-checkout_billingType_formLabel p-home_demo_formLabel fs-14x18">Phone number</Typography.Text>
                <Typography.Text extendClasses="p-checkout_text">{handlePhoneChange(billingData.phone)}</Typography.Text>
              </Col>
            </Row>
            <Row>
              <Col>
                <Typography.Text fontweight="600" extendClasses="p-checkout_billingType_formLabel p-home_demo_formLabel fs-14x18">Email to create admin account</Typography.Text>
                <Typography.Text extendClasses="p-checkout_text">{billingData.email}</Typography.Text>
              </Col>
            </Row>
          </div>
        </div>
        <div className="p-checkout_spacingBottom">
          <Typography.Text fontweight="600" extendClasses="p-checkout_titleProduct p-checkout_billingInfo_spacing fs-20x24">
            Invoice Information
          </Typography.Text>
          <div className="p-checkout_buyerInfo">
            <Row>
              <Col className="p-checkout_buyerInfo_col">
                <Typography.Text fontweight="600" extendClasses="p-checkout_billingType_formLabel p-home_demo_formLabel fs-14x18">Invoice Recipient Type</Typography.Text>
                <Typography.Text extendClasses="p-checkout_text">
                  {billingData.invoiceType.toLowerCase()
                    .split(/\s+/)
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ')}
                </Typography.Text>
              </Col>
            </Row>
            <Row gutter={[16, 16]}>
              <Col className="p-checkout_buyerInfo_col">
                <Typography.Text fontweight="600" extendClasses="p-checkout_billingType_formLabel p-home_demo_formLabel fs-14x18">
                  {billingData.invoiceType === 'business'
                    ? 'Tax ID' : 'National ID'}
                </Typography.Text>
                <Typography.Text extendClasses="p-checkout_text">
                  {billingData.invoiceType === 'business' ? (billingData.invoice as IBusinessInfo).taxId
                    : (billingData.invoice as IIndividualInfo).nationalId}
                </Typography.Text>
              </Col>
              <Col style={{ flex: 1 }} className="p-checkout_buyerInfo_col">
                <Typography.Text fontweight="600" extendClasses="p-checkout_billingType_formLabel p-home_demo_formLabel fs-14x18">
                  {billingData.invoiceType === 'business'
                    ? 'Company name' : 'Full name'}
                </Typography.Text>
                <Typography.Text extendClasses="p-checkout_text">
                  {billingData.invoiceType === 'business' ? (billingData.invoice as IBusinessInfo).companyName
                    : (billingData.invoice as IIndividualInfo).fullName}
                </Typography.Text>
              </Col>
            </Row>
            <Row>
              <Col style={{ flex: 1 }} className="p-checkout_buyerInfo_col">
                <Typography.Text fontweight="600" extendClasses="p-checkout_billingType_formLabel p-home_demo_formLabel fs-14x18">Full Address</Typography.Text>
                <Typography.Text extendClasses="p-checkout_text">{billingData.invoice.fullAddress}</Typography.Text>
              </Col>
            </Row>
            <Row>
              <Col>
                <Typography.Text fontweight="600" extendClasses="p-checkout_billingType_formLabel p-home_demo_formLabel fs-14x18">Invoice Email</Typography.Text>
                <div className="p-checkout_textTagWrap">
                  {billingData.invoice.invoiceEmail?.map((item) => (
                    <Typography.Text extendClasses="p-checkout_textTag">{item}</Typography.Text>
                  ))}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div className="p-checkout_confirmation_payment p-checkout_productWrap">
        <div>
          <Typography.Text fontweight="600" extendClasses="p-checkout_billingType_formLabel p-home_demo_formLabel fs-14x18">Support payment method</Typography.Text>
          <div className="p-checkout_confirmation_paymentMethods">
            <ul className="p-checkout_confirmation_listPayment">
              {(billingType === 'one-time' ? paymentMethodsOnetime : paymentMethodsSubscription)
                .map((item) => (
                  <li
                    className="p-checkout_confirmation_radio"
                    key={item}
                  >
                    <Typography.Text extendClasses="p-checkout_text fs-14x18">{item}</Typography.Text>
                  </li>
                ))}
            </ul>
          </div>
          <Divider style={{ margin: '32px 0' }} />
          <div>
            <Row justify="space-between">
              <Typography.Text extendClasses="fs-16x18">Total</Typography.Text>
              <Typography.Text fontweight="600" extendClasses="p-checkout_packageCard_amount fs-18x21">
                {total.toLocaleString('en-US')}
                {' '}
                VNĐ
              </Typography.Text>
            </Row>
            <div className="p-checkout_confirmation_agreement">
              <Checkbox onChange={() => setChecked(!checked)} />
              <Typography.Text extendClasses="p-checkout_confirmation_agreementText fs-14x18">
                I agree to Ask2Auto
                {' '}
                <span className="p-checkout_confirmation_link" onClick={() => window.open('/privacy-policy', '_blank')}>privacy policy</span>
                {' '}
                and
                {' '}
                <span className="p-checkout_confirmation_link" onClick={() => window.open('/terms-and-conditions', '_blank')}>terms</span>
              </Typography.Text>
            </div>
            <Button
              onClick={() => (billingType === 'one-time' ? handleCheckout() : setOpenModal(true))}
              disabled={!checked}
              extendClasses={mapModifiers('fButton fButton-primary p-checkout_confirmation_button', !checked ? 'disabled' : 'active')}
            >
              Select Payment Method
            </Button>
          </div>
          <div className="p-checkout_confirmation_support">
            <Typography.Text extendClasses="p-checkout_confirmation_supportText">Supported by payment gateway</Typography.Text>
            <div className="p-checkout_confirmation_supportImg">
              <Image extendClasses="p-checkout_confirmation_extend" imgSrc={nganLuongImg} alt="nganLuongImg" ratio={394 / 87} />
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={openModal}
        className="p-checkout_modal"
        width={800}
        title="Notice"
        closeIcon
        cancelButton={{
          handleClick: () => {
            setOpenModal(false);
          },
        }}
        okButton={{
          handleClick: () => {
            setOpenModal(false);
          },
        }}
      >
        <div className="p-checkout_modal_content">
          <Divider style={{ margin: '8px 0 16px 0' }} />
          <Image extendClasses="p-checkout_modal_image" imgSrc={imgCard} alt="demoImg" ratio={1447 / 680} />
          <Typography.Text extendClasses="p-checkout_modal_description f-14x18">
            To enable automatic billing, you must agree to save
            your card information with our payment partner
          </Typography.Text>
          <Divider style={{ margin: '12px 0' }} />
          <div className="p-checkout_modal_buttonWrap">
            <Button onClick={() => handleCheckout()} variant="primary" extendClasses="p-checkout_modal_button">I understand</Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Confirmation;
